import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { GetSessionsResponse, TerminateAllSessionsResponse, DeleteSessionResponse } from "@/shared/services/interface/requests/sessions";
import { IBaseResponse } from "@/shared/services/interface/responses/IBaseResponse";

class SessionService {
    constructor() {}

    public async deleteSession(id: string): Promise<IBaseResponse<DeleteSessionResponse>> {
        const response = await httpClient.delete<DeleteSessionResponse>(API_ROUTES.Session.terminate(id));
        return response;
    }

    public async terminateAllSessions(): Promise<IBaseResponse<TerminateAllSessionsResponse>> {
        const response = await httpClient.delete<TerminateAllSessionsResponse>(API_ROUTES.Session.terminateAll);
        return response;
    }

    public async getSessions(): Promise<IBaseResponse<GetSessionsResponse>> {
        const response = await httpClient.get<GetSessionsResponse>(API_ROUTES.Session.getSessions);
        return response;
    }
}

export const sessionService = new SessionService();
export default new SessionService();